import React from "react";

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import "./Memberships.scss";

const {UniversalModal} = Framework.Elements;

const breadcrumbsStatic = [
	{
		name: "Memberships",
		url: "/memberships",
		icon: "id-card-o",
	},
];

export default class Memberships extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid memberships-page">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<div className="memberships-header">
					<div>
						<h3>Memberships</h3>
						<span>Plans and customer billing</span>
					</div>
					<div className="memberships-header-badge">
						<i className="fa fa-repeat"/>
						<span>Recurring</span>
					</div>
				</div>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Memberships
						roles={this.props.roles}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						onAddPlan={this.toggle("modalMembership")}
					/>
				</Framework.Errors.General>

				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					name="Membership"
					title="Add Membership Plan"
					submitLabel="Add Plan"
					object={Objects.Membership}
					history={this.props.history}
					toggle={this.state.modalMembership}
					reportClose={this.reportClose("modalMembership")}
					afterSave={this.handleAfterSave}
					size="lg"
					project={'pos'}
				/>
			</div>
		);
	}
}
